import React from 'react';
import { getAvatarColor, getInitials } from '../../lib/participantUtils';
import { cn } from '../../lib/utils';

interface ParticipantAvatarProps {
  name: string;
  photoUrl?: string;
}

const ParticipantAvatar: React.FC<ParticipantAvatarProps> = ({
  name,
  photoUrl,
}) => {
  if (photoUrl) {
    return (
      <div className="w-8 h-8 rounded-full overflow-hidden">
        <img
          src={photoUrl}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            target.nextElementSibling?.classList.remove('hidden');
          }}
        />
        <div className="hidden w-full h-full flex items-center justify-center text-white text-xs font-medium bg-gray-500">
          {getInitials(name)}
        </div>
      </div>
    );
  }

  const initials = getInitials(name);
  const color = getAvatarColor(name);

  return (
    <div
      className={cn(
        'w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-medium',
        color
      )}
    >
      {initials}
    </div>
  );
};

export default ParticipantAvatar;
